import { Dialog } from "@headlessui/react";

const SessionPickerModal = ({ isOpen, sessions, onSelect }) => {
  return (
    <Dialog open={isOpen} onClose={() => onSelect(null)} className="relative z-50">
      <div className="fixed inset-0 bg-black/50" aria-hidden="true" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="bg-white rounded-lg p-6 shadow-lg max-w-md w-full z-50">
          <Dialog.Title className="text-lg font-bold mb-4">
            Choose a session period
          </Dialog.Title>
          <div className="space-y-2">
            {sessions.map((session, idx) => (
              <button
                key={idx}
                onClick={() => {
                  onSelect(session);
                }}
                className="w-full p-3 rounded border hover:bg-blue-100 text-left"
              >
                {session.period === "M" ? "Morning" : "Afternoon"}{" "}
                {session.start_ts
                  ? ` - ${new Date(session.start_ts * 1000).toLocaleTimeString([], {
                      hour: "2-digit",
                      minute: "2-digit",
                    })}`
                  : ""}
              </button>
            ))}
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default SessionPickerModal; 
